import { blueprints } from '../blueprints/blueprints-sidecar'
import { asteroids } from '../entities/asteroids-sidecar'
import { scene } from '../main/scene-sidecar'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'
import { ITileShip } from '../tiles/tilesShip'

export function run(t: ITileShip, isLeft: boolean) {
  let ctx = scene.getContext()
  let std = tilesDataShip.getStandard()
  let as = asteroids.findAtSpot(t.i, t.j, (c) => true)
  let current = blueprints.findAtSpot(t.i, t.j, (c) => c.data.type === 'mine')
  if (isLeft) {
    if (as) {
      if (!current) {
        let bp = blueprints.create('mine')
        blueprints.moveToTile(bp, ctx.mapShip, t.i, t.j)
      }
    } else if (t.dataFloor === std.asteroid) {
      if (!current) {
        let bp = blueprints.create('mine')
        blueprints.moveToTile(bp, ctx.mapShip, t.i, t.j)
      }
    }
  } else {
    if (current) {
      blueprints.kill(current)
    }
  }
}
